module.exports = __webpack_public_path__ + "static/media/painting4.ae59962c.jpg";